module.exports = __webpack_public_path__ + "static/chiefs-e772d39cb37f5ef9a96a7ab7a2b89ee8.jpg";